import { Col, Row } from 'antd';
import React, { FC } from 'react';
import MainLayout from 'src/layouts/main/main.layout';
import { IProps } from 'src/types/layout.types';
import Protected from '../auth-protector';

const OnBoardingPage: FC<IProps> = ({ children }) => {
	return (
		<>
			<Protected>
				<MainLayout removeMenu>
					<Row justify={'center'}>
						<Col xs={23} md={20}>{children}</Col>
					</Row>
				</MainLayout>
			</Protected>
		</>
	);
};

export default OnBoardingPage;
